import { useDateTimeFormat } from '@core/shared';
import { WebinarDataWithAssets } from '@core/swagger-client';
import { CalendarAlt, Clock, DescriptionItem, TestWebinarBadge } from '@core/ui';
import { DateTime } from 'luxon';
import { Trans, useTranslation } from 'react-i18next';

export const RegisterForBroadcastInfo = ({ webinar }: { webinar: WebinarDataWithAssets }) => {
    const { t } = useTranslation();

    const { dateFormat, webinarDate, webinarTime } = useDateTimeFormat(webinar.broadcastDateTime, {
        dateFormat: 'yyyy-LL-dd',
        webinarDate: DateTime.DATE_MED_WITH_WEEKDAY,
        webinarTime: DateTime.TIME_24_SIMPLE
    });

    return (
        <div className="bg-accent-lighter rounded-b-xl md:rounded-t-xl -mt-16 md:-mt-8 xl:-mt-12 mb-8 px-4 md:px-6 max-md:pt-10 py-6 -mx-4 md:-mx-6">
            {t('Pages.Register.Webinar.Interested')}
            {webinar.isTest && (
                <div className="mt-2">
                    <TestWebinarBadge />
                </div>
            )}
            <p className="font-w-heading font-accent text-xl sm:text-2xl wrap-break-word text-balance max-w-full my-4">{webinar.title}</p>
            <dl className="flex flex-wrap gap-x-4">
                <DescriptionItem
                    classNames="flex items-start whitespace-nowrap"
                    termClassNames="flex flex-none"
                    icon={<CalendarAlt classNames="w-6 me-1.5 stroke-current" />}
                    label={t('WebinarDetails.Label.Date')}
                    hideLabel
                >
                    <time dateTime={dateFormat}>{webinarDate}</time>
                </DescriptionItem>
                <DescriptionItem
                    classNames="flex items-start whitespace-nowrap"
                    termClassNames="flex flex-none"
                    icon={<Clock classNames="w-6 me-1.5 stroke-current" />}
                    label={t('WebinarDetails.Label.Time')}
                    hideLabel
                >
                    <time dateTime={webinarTime}>{webinarTime}</time>
                </DescriptionItem>
            </dl>
            <div className="italic mt-2">
                <Trans components={{ br: <br /> }} i18nKey="Pages.Register.Webinar.CreateAccount" />
            </div>
        </div>
    );
};
